// Carries the HTTP status so callers can tell a terminal failure (404: signed
// in to Clerk but no row in `users`) from a retryable one (401 on a stale
// session cookie, 5xx, network).
export class UserFetchError extends Error {
  constructor(
    public readonly status: number,
    message: string,
  ) {
    super(message);
    this.name = "UserFetchError";
  }
}

export async function getCartrackedUserByEmail(email: string) {
  const res = await fetch(`/v2/api/user?email=${encodeURIComponent(email)}`);

  if (!res.ok) {
    throw new UserFetchError(
      res.status,
      res.statusText || `HTTP ${res.status}`,
    );
  }

  return await res.json();
}
